import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { BreedSearchResultPropTypes } from 'dpl/shared/utils/customPropTypes';
import { FancyDropdownMenu } from 'dpl/components/FancyDropdown';
import BreedSearchResultsList from 'dpl/components/BreedSearch/BreedSearchResultsList';
import BreedSearchResultsBreedTypeLearnLink from 'dpl/components/BreedSearch/BreedSearchResultsBreedTypeLearnLink';
import LoadingWrapper from 'dpl/components/LoadingWrapper';

export default function BreedSearchResults({
  isOpen,
  breeds,
  query,
  breedType,
  isLoading,
  onSelectItem
}) {
  if (!isOpen) {
    return null;
  }

  const breedTypeManagedByParent = breedType !== null;

  return (
    <FancyDropdownMenu
      className="BreedSearchResults overflow-y-auto br3 bg-white mt2"
      contentClassName={classnames({
        pb2: breedTypeManagedByParent
      })}
    >
      <LoadingWrapper isLoading={isLoading}>
        <BreedSearchResultsList
          inDropdown
          breeds={breeds}
          query={query}
          breedType={breedType}
          onSelectItem={onSelectItem}
        />
        {!breedTypeManagedByParent && (
          <div className="bg-near-white box-shadow-2 bottom-0 left-0 right-0 ph4 pv4 f2 sticky">
            <BreedSearchResultsBreedTypeLearnLink />
          </div>
        )}
      </LoadingWrapper>
    </FancyDropdownMenu>
  );
}

BreedSearchResults.propTypes = {
  query: PropTypes.string.isRequired,
  breeds: PropTypes.arrayOf(PropTypes.shape(BreedSearchResultPropTypes))
    .isRequired,
  isOpen: PropTypes.bool.isRequired,
  breedType: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  onSelectItem: PropTypes.func
};

BreedSearchResults.defaultProps = {
  breedType: null,
  onSelectItem: null
};
